Greenmile.Route = Greenmile.Route || {};

Greenmile.Route.AssignTag = function ({
  modalContentSelector = '#Route .popupFormContainer',
  routeId = App.Forms.Route.form.fields.id.getValue(),
  scopeBlock = '#Route form.MonetUIForm.Route',
  selector = '#Route #form_and_grid',
  successCallback,
  afterRemoveItems
} = {}) {

    this.modalForm = null;

    this.showAssignTag = function () {

        this.modalForm.showModalForm();

    };

    this.addFormToModalContent = () => {

        const modalContent = document.querySelector(modalContentSelector);

        if (modalContent) {

            try {

                const contentToModal = this.constructFormAssignTag(routeId);

                modalContent.appendChild(contentToModal.html);

                const lookupContainer = modalContent.querySelector('.form-horizontal');
                lookupContainer.appendChild(contentToModal.field.rootEl);

                this.populateListTags(routeId, contentToModal.field);
                this.addEventListenners();

            } catch (e) {
                const error = new Monet.Exception.ReturnError(this, "No add form to modal.");
                error.console();
            }
        } else {
            const exception = new Monet.Exception.ReturnError(this, "No modal to add form.");
            exception.console();
        }

    };

    this.buildTemplate = function (routeIdValue) {
        const layout = {
            "items": [
                {
                    "tag": "form",
                    "items": [
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingTag.btnSave"),
                                                "name": "btn_save_assign_tag",
                                                "id": "btn_save_assign_tag",
                                                "class": "btn",
                                                "style": "float:right;"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "value": Monet.I18n.getResourcesByKey("Route.AssingHelper.btnExit"),
                                                "name": "btn_exit_assign_tag",
                                                "id": "btn_exit_assign_tag",
                                                "class": "btn"
                                            }

                                        }
                                    ],
                                    "attributes": {
                                        "style": "position:relative; float:left; width: 100%",
                                        "class": "standard-form-buttons"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "attributes": {
                                                "class": "monetInlineAlerContainer"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "hidden",
                                                "id": "route_id",
                                                "name": "route.id",
                                                "value": routeIdValue,
                                                "class": "modelAttribute"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span8"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "html": "",
                                            "attributes": {
                                                "class": "form-horizontal"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "span4"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "row"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "form_assign_tag"
                    }
                }
            ]
        };

        return ( new Monet.UI.LayoutGenerator(layout) ).render();

    };

    this.constructFormAssignTag = function (routeId) {

        try {

            let field = new Monet.UI.Fields.PowerLookupList();

            field.setId('tag');
            field.setNameSpace('tag');
            field.setLookUpEntity('Tag');
            field.setDisplayKey('description');
            field.setTextLabel(Monet.I18n.getResourcesByKey('Route.AssingTag.label.tag'));
            field.setInputName('description');
            field.customCriteriaChain = [{
                attr: "tagType",
                eq: "ROUTE"
            }];
            field.render();

            return {
                html: this.buildTemplate(routeId),
                field
            };

        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "No form to assign tag.");
            error.console();
        }

    };

    this.populateListTags = async function (routeId, lookupField) {
        try {
            const route = new App.Routers.Route();
            const dataToLookup = [];
            const tags = await route.getTagsByRoute(routeId);
            const tagsTotal = tags.length;

            if (tagsTotal) {
                for (var i = 0; i < tagsTotal; i++) {
                    dataToLookup.push(tags[i].tag);
                }
            }
            lookupField.setValue(dataToLookup);

            tags.forEach(tagData => {
                let trashIcon = document.querySelector('.item_lookuplist_tag_' + tagData.tag.id + ' .del_item_added');
                trashIcon.addEventListener('click', () => {
                    let model = new App.Models.RouteTagAssignment();
                    model.unassignToRoute(
                      {
                        assignmentId: tagData.id
                      },
                      () => {
                        afterRemoveItems?.();
                      }
                    );
                });
            });

            const utils = new Greenmile.Route.ModalUtils();
            utils.removeAllActionListener(
              lookupField,
              tags,
              'tag',
              false,
              () => {
                afterRemoveItems?.();
              }
            );

        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "No populate list tags.");
            error.console();
        }
    };

    this.assignTagToRoute = () => {

      const assignToRouteCallback = () => {
        this.modalForm.closeModalWindow();
        successCallback?.();
      };

      if (this.validateForm()) {
        try {
          const selectorTags = "#form_assign_tag #tag_list input[type='hidden']";
          const tags = document.querySelectorAll(selectorTags);
          const totalTags = tags.length;
          const model = new App.Models.RouteTagAssignment();

          for (let i = 0; i < totalTags; i++) {
            const tag = tags[i];

            const data = {
              route: {
                id: routeId
              },
              tag: {
                id: tag.value
              }
            };

            model.assignToRoute({ list: data }, assignToRouteCallback);
          }
        } catch (e) {
          const error = new Monet.Exception.ReturnError(this,"No assign tag to route.");
          error.console();
        }
      }
    };


    this.addEventListenners = function () {

        try {

            const that = this;

            const btnSave = document.querySelector("#form_assign_tag #btn_save_assign_tag");
            const btnExit = document.querySelector("#form_assign_tag #btn_exit_assign_tag");

            btnSave.onclick = function () {
                that.assignTagToRoute();
            };

            btnExit.onclick = function () {
                that.modalForm.closeModalWindow();
            };

        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "No add event listenner to form.");
            error.console();

        }

    };

    this.validateForm = function () {

        let isValid = true;

        try {

            const fields = document.querySelectorAll("#form_assign_tag #tag_list input[type='hidden']");

            if (!fields.length) {

                isValid = false;

                const errorMessages = {
                    errorMessages: [Monet.Form.Messages.mountErrorMessageObject("Route.AssingTag.tagNotSelected")]
                };

                const monetMessage = new Monet.Form.Messages.InlineMessage();
                monetMessage.setScope("#form_assign_tag");
                monetMessage.setInfoType("error");
                monetMessage.setMessage(errorMessages);
                monetMessage.triggerMessage();
            }

        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "No validate form.");
            error.console();
        }
        return isValid;
    };

    const init = () => {
      const options = { width: 500, height: 400 };
      const callbacks = {
        onAfterShowModalForm: this.addFormToModalContent
      };
      this.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
    };

    init(this);

};
